import type { TemplateInput } from '@amzn/mulberry-internal-typescript-client';
import { getAsinStage } from 'src/utils/roadieHelper';

/**
 * Resolve the engagement ID to use for the current ASIN stage.
 * - Gamma: prefer `gammaEngagementId`, fall back to `engagementId`.
 * - Beta / Prod: always `engagementId` (the current-stage / prod ID).
 */
export const getActiveEngagementId = (
  template: TemplateInput | null | undefined,
): string | undefined => {
  if (!template) return undefined;
  return getAsinStage() === 'Gamma'
    ? template.gammaEngagementId ?? template.engagementId
    : template.engagementId;
};
